import { render, staticRenderFns } from "./useNotic.vue?vue&type=template&id=794be11c&scoped=true"
import script from "./useNotic.vue?vue&type=script&lang=js"
export * from "./useNotic.vue?vue&type=script&lang=js"
import style0 from "./useNotic.vue?vue&type=style&index=0&id=794be11c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794be11c",
  null
  
)

export default component.exports